/**
 * Represent a function that capitalizes first letter of a string
 * @param {string} str - string to capitalize
 * @returns {string} capitalized string
 */
export const capitalize = (str: string): string => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

